var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"img-view"},[_c('div',{staticClass:"img"},[_c('img',{attrs:{"src":_vm.url}})]),_c('div',{on:{"click":_vm.close}},[_c('SvgIcon',{attrs:{"iconClass":"imgClose","className":"icon"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }